export default __webpack_public_path__ + "static/media/background-2.cd1f22d7.svg";